import React from "react";
import Tabs from "@mui/material/Tabs";
import { TabScrollButton, Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";

// const TAB_WIDTH = 160;
// const StyledBadge = withStyles((theme) => ({
//   badge: {
//     right: 7,
//     top: 15,
//     border: `2px solid rgb(2, 31, 71)`,
//     padding: '0 4px',
//     backgroundColor: 'rgba(255,255,255,0.75)',
//     color: 'rgb(2, 31, 71)'
//   },
// }))(Badge);

const ScrollButtonComponentCustom = (props) => {
  // const { disabled, direction } = props;
  // const length = useSelector((state)=> state.layout.layoutSelected?.tabs?.length);

  // const [page, setPage] = useState(1);
  // const { onClick, ...anotherProps} = props;
  // const cantVisible = Math.round((window.innerWidth - 80) / TAB_WIDTH);

  // const remain = Math.round(length - cantVisible);

  // const handleClick = () => {
  //   if(direction === "right"){
  //     setPage((prev)=>prev+1);
  //   }else {
  //     setPage((prev)=>prev-1);
  //   }
  //   onClick();
  // }

  // const getRemain = () => {
  //   let result;
  //   if(page === 1){
  //     result = remain - cantVisible;
  //   }else {
  //     result = remain - (cantVisible * page)
  //   }
  //   return Math.round(result);
  // }

  return (
    <Tooltip arrow title="Press to view more tabs">
      <span>
        {/* <StyledBadge badgeContent={disabled ? 0 : getRemain()}> */}
        <TabScrollButton {...props} />
        {/* </StyledBadge> */}
      </span>
    </Tooltip>
  );
};

export const tabHeight = "35px"; // default: '48px'
const StyledTabs = withStyles((theme) => ({
  root: {
    minHeight: tabHeight,
    height: tabHeight,
    maxWidth: "100vw",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    "& > span": {
      width: "calc(100% - 4px)",
      backgroundColor:
        theme.palette.type === "dark"
          ? theme.palette.text.primary
          : theme.palette.background.default,
    },
  },
}))((props) => (
  <Tabs
    {...props}
    ScrollButtonComponent={ScrollButtonComponentCustom}
    TabIndicatorProps={{ children: <span /> }}
  />
));

export default StyledTabs;
